export enum UnitDocumentReasonCode {
  /** Not a real status in Unit */
  None = 0,
  PoorQuality = 1,
  NameMismatch = 2,
  SSNMismatch = 3,
  AddressMismatch = 4,
  DOBMismatch = 5,
  ExpiredId = 6,
  EINMismatch = 7,
  StateMismatch = 8,
  Other = 9,
}

// tslint:disable-next-line:no-namespace
export namespace UnitDocumentReasonCode {
  export function toString(enumValue: UnitDocumentReasonCode): string {
    switch (enumValue) {
      case UnitDocumentReasonCode.None:
        return null;
      case UnitDocumentReasonCode.PoorQuality:
        return 'Poor quality';
      case UnitDocumentReasonCode.NameMismatch:
        return 'Name mismatch';
      case UnitDocumentReasonCode.SSNMismatch:
        return 'SSN mismatch';
      case UnitDocumentReasonCode.AddressMismatch:
        return 'Address mismatch';
      case UnitDocumentReasonCode.DOBMismatch:
        return 'DOB mismatch';
      case UnitDocumentReasonCode.ExpiredId:
        return 'Expired ID';
      case UnitDocumentReasonCode.EINMismatch:
        return 'EIN mismatch';
      case UnitDocumentReasonCode.StateMismatch:
        return 'State mismatch';
      case UnitDocumentReasonCode.Other:
        return 'Other';
      default:
        return null;
    }
  }

  export function listAll() {
    return [
      UnitDocumentReasonCode.PoorQuality,
      UnitDocumentReasonCode.NameMismatch,
      UnitDocumentReasonCode.SSNMismatch,
      UnitDocumentReasonCode.AddressMismatch,
      UnitDocumentReasonCode.DOBMismatch,
      UnitDocumentReasonCode.ExpiredId,
      UnitDocumentReasonCode.EINMismatch,
      UnitDocumentReasonCode.StateMismatch,
      UnitDocumentReasonCode.Other,
    ];
  }

  export function parse(str: string): UnitDocumentReasonCode {
    return UnitDocumentReasonCode[str];
  }
}

export default UnitDocumentReasonCode;
